export interface CancellableTimeout {
  start(): void;
  cancel(): void;
}

export interface CancellableTimeoutOptions {
  callback: Function;
  cancelCallback?: Function;
  ms: number;
}

export function getCancellableTimeout(
  options: CancellableTimeoutOptions,
): CancellableTimeout {
  const { callback, cancelCallback, ms } = options;
  let timeoutId: number;
  let cancelled = false;

  const start = () => {
    if (!cancelled) {
      timeoutId = window.setTimeout(callback, ms);
    }
  };
  const cancel = () => {
    cancelled = true;
    window.clearTimeout(timeoutId);

    if (cancelCallback) {
      cancelCallback();
    }
  };

  return { start, cancel };
}
